export default __webpack_public_path__ + "static/media/lootbox-2.71c0dea3.png";